import { ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE } from '../../plugins/utils/events'
import { toast } from 'vue3-toastify'

export default class Notifications {
  constructor() {}

  start() {
    document.addEventListener(ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE, this.alertNotif.bind(this))
  }

  stop() {
    document.removeEventListener(ALERT_NOTIF_MESSAGE_RECEIVED_EVENT_TYPE, this.alertNotif.bind(this))
  }

  alertNotif(e) {
    const { detail } = e
    toast(`<div class="alertInfo">Notification<br>Message: ${detail.message}</div>`, {
      dangerouslyHTMLString: true,
      closeOnClick: false,
      autoClose: 15000
    })
  }
}